import React from 'react';
import PropTypes from 'prop-types';
import Confirm from './forked/layout/Confirm';

/**
 * Wrapper for the confirm pop-up component,
 * expecially for the confirm pop-up when you leave a page without save your changes
 */
const LeaveConfirmWrapper = props => {
  return (
    <Confirm
      {...props}
      title="Leave Page Without Saving?"
      content={
        <div>
          <p style={{ margin: 0 }}>You made some changes on this page.</p>
          If you leave now, the changes will be lost.
        </div>
      }
      confirm="ra.action.confirm_leave"
    />
  );
};

LeaveConfirmWrapper.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default LeaveConfirmWrapper;
